import { atom } from 'recoil'

export const collectionState = atom({
    key: 'collectionAtom',
    default: null,
})